<template>
  <div class="club-wrapper">
    <div class="centered city-addition">
      <draggable v-model="clubsObject" :options="{ disabled: editableClub !== null }">
        <span v-for="club in clubsObject" @click="handleGetClub(club.id)" class="city-wrapper">
          <router-link :key="club.id"
          :to="{ name: 'FinancialClub', params: { id: club.id }  }"
          v-if="editableClub !== club.id"
          :class="$route.params.id === club.id || !$route.params.id && clubs[0].id === club.id? 'is-active' : '' "
          class="city-title">{{club.city}}
          </router-link>
          <span v-else class="edit-city-wrapper">
            <a class="delete hide-edit-city" @click="toggleEditClub(club.id)"></a>
            <b-input v-model="newClubCity"
            class="edit-city-input"></b-input>
            <img src="/static/img/icons/apply.svg" class="apply-icon is-medium" @click="handleUpdateFinancialClubs"/>
          </span>
          <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEditClub(club.id)"/>
        </span>
      </draggable>
      <span class="button-wrapper city-addition-wrapper" @click="toggleCityAddition" v-if="!cityAdditionVisible">
        <a class="button is-info">+</a> Добавить город
      </span>
      <b-field class="city-addition-input" v-if="cityAdditionVisible">
          <b-input placeholder="Введите название города" v-model="cityName"></b-input>
          <span class="city-addition-button is-primary button" @click="handleAddCity">Добавить</span>
          <span class="city-addition-button is-warning button" @click="toggleCityAddition">Отмена</span>
      </b-field>
    </div>
    <div class="club" v-if="clubObject">
      <div class="club-header-wrapper columns" v-bind:style="headerStyle">
        <div class="column logo-wrapper">
          <div class="rounded-photo-wrapper club-photo centered"  v-bind:style="logoContainerStyle">
            <div v-if="!clubObject.logo" @click="handleLoadLogoImage">
              <span>Загрузить лого представительства</span>
            </div>
            <img  v-else src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteClubLogoImage(clubObject.id)"/>
          </div>
          <input type="file" id='photo' @change='loadPhotoLogoImage' hidden ref="loadLogoImage"/>
        </div>
        <div class="club-header column">
          <b-input @change="handleUpdateFinancialClub" v-model="clubObject.description" placeholder="По каким днями и где встречаемся"></b-input>
          <b-input @change="handleUpdateFinancialClub" v-model="clubObject.conditions" placeholder="Условия, начало встречи, атмосфера"></b-input>
          <div class="centered is-full-width">
            <span class="button-wrapper" @click="handLoadClubPhoto"><a class="button is-info">+</a>Загрузить фото</span>
            <input type="file" id='photo' @change='handleLoadClubBackgroundPhoto' hidden ref="loadBackgroundPhoto"/>
          </div>
        </div>
      </div>
      <div class="centered" v-if="!clubObject.announcement">
        <span class="button-wrapper" @click="handleAddAnnouncement">
          <a class="button is-info">+</a> Добавить срочное объявление
        </span>
      </div>
      <div class="centered" v-if="clubObject.financialClubMembers.length">
        <span class="link members-link" @click="showMembers">Просмотреть список заявок</span>
      </div>
      <div class="announcement" v-if="clubObject.announcement">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteClubAnnouncement(clubObject.id)"/>
        <b-field class="title">
          <b-input
          @change="handleUpdateFinancialClub"
          placeholder="Заголовок объявления"
          v-model="clubObject.announcement.title"/>
        </b-field>
        <b-field>
          <b-input
          @change="handleUpdateFinancialClub"
          placeholder="Текст объявления"
          v-model="clubObject.announcement.description"/>
        </b-field>
        <span>Период размещения объявления на сайте</span>
        <div class="columns">
          <div class="column is-half">
            <el-date-picker
              type="date"
              :editable="false"
              @change="announcementDateChanged"
              v-model="announcement.start"
              placeholder="c">
            </el-date-picker>
          </div>
          <div class="column is-half">
            <el-date-picker
              type="date"
              :editable="false"
              @change="announcementDateChanged"
              v-model="announcement.end"
              placeholder="по">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="centered">
          <a @click="handleAddMeeting" class="button is-info">+ Добавить встречу</a>
      </div>
      <div class="columns meetings is-multiline">
        <Meeting v-for="meeting in clubObject.meetings" :key="meeting.id" :meeting="meeting" />
      </div>
      <div class="map-container">
        <h2 class="has-text-centered">Укажите адрес на карте</h2>
        <gmap-map
          :center="center"
          :options="{scrollwheel: false}"
          :zoom="15"
          style="height: 350px"
          @click="selectAddress"
        >
          <gmap-marker
           :key="index"
           v-for="(m, index) in markers"
           :position="m.position"
           :clickable="true"
           :draggable="true"
          ></gmap-marker>
        </gmap-map>
        <div class="centered"><div class="button delete-pin" @click="deletePin">Удалить метку</div></div>
      </div>
      <div class="columns club-information">
        <div class="column is-two-thirds editor-container">
          <b-field label="Обсуждаем в дружеской обстановке">
            <Editor :editorToolbar="customToolbar" v-model="talks" id="talks"/>
          </b-field>
          <span class="button-wrapper" @click="handleLoadPhoto">
            <a class="button is-info">+</a>
            Добавить логотип организатора. Форматы: .png, .jpeg
          </span>
          <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
          <div class="columns is-multiline">
            <div class="column is-one-quarter" v-for="logo in clubObject.logos">
              <div class="logo-wrapper" >
                <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteSponsorLogo(logo)"/>
                <img :src='"/upload/photos/" + logo' v-if="!logo.id"/>
                <img :src='logo.base64photo' v-else/>
              </div>
            </div>
          </div>
        </div>
        <div class="column additional-information">
          <b-field label="Название места">
            <b-input @change="handleUpdateFinancialClub" v-model="clubObject.placeName" placeholder="Введите название места"></b-input>
          </b-field>
          <b-field label="Где проходит">
            <b-input @change="handleUpdateFinancialClub" v-model="clubObject.address" v-on:blur="getAddress()" placeholder="Введите адресс"></b-input>
          </b-field>
          <b-field label="Доп. информация (где парковка, сколько стоит)">
            <b-input @change="handleUpdateFinancialClub" v-model="clubObject.additionalInformation" type="textarea"></b-input>
          </b-field>
          <b-field label="Ссылка на место проведения клуба">
            <Editor :editorToolbar="urlEditorToolbar" v-model="placeUrl" id="place-url"/>
          </b-field>
        </div>
      </div>
      <div class="centered">
        <b-field label="Кому будут полезны встречи" class="benefits">
          <Editor :editorToolbar="urlEditorToolbar" v-model="createdFor" id="createdFor"/>
        </b-field>
      </div>
      <h2 class="has-text-centered">Постоянные спикеры</h2>
      <div class="speakers columns is-multiline">
        <div class="is-one-third column" v-for="speaker in clubObject.clubSpeakers" :key="speaker.id">
          <Speaker :speaker="speaker"/>
        </div>
      </div>
      <div class="centered">
        <span class="button-wrapper centered" @click="handleAddSpeaker()">
          <a class="button is-info">+</a>
          Добавить спикера
        </span>
      </div>
      <div class="centered">
        <span class="button-wrapper" @click="handleAddClubPhoto">
          <input type="file" id='photo' @change='clubPhotoAdded' hidden ref="loadClubPhotoButton"/>
          <a class="button is-info">+</a>
          Добавить фото из финансового клуба
        </span>
      </div>
      <swiper :options="swiperOption" v-if="clubObject.photos.length">
        <swiper-slide  v-for="photo in clubObject.photos" :key="photo">
          <div class="centered">
            <img :src='"/upload/photos/" + photo' v-if="!photo.id"/>
            <img :src='photo.base64photo' v-else/>
            <a class="button is-danger delete-club-photo" @click="deleteClubPhoto(photo)">
              Удалить
            </a>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="save-content-button centered">
        <div class="button save-content" @click="handleSaveFinancialClib(clubObject)">
          СОХРАНИТЬ
        </div>
      </div>
      <div class="columns has-text-centered club-footer">
        <div class="column is-one-third delete-club" @click="deleteClub(clubObject.id)">Удалить</div>
        <div class="column hide">
          <b-switch v-model='clubObject.isHidden' class="hide-from-site" @change="handleUpdateFinancialClub">
            Скрыть с сайта
          </b-switch>
        </div>
      </div>
    </div>
    <el-dialog class="webinar-dialog" v-if="clubObject"
      :visible.sync="dialogVisible"
      >
      <div class="club-members">
        <span class="club-members-count">
          Количество заявок: {{clubObject.financialClubMembers.length}}
        </span>
        <table class="club-members-table">
          <thead>
            <tr>
              <td class="name">Имя</td>
              <td class="lastname">Фамилия</td>
              <td class="email">Email</td>
              <td class="phone">Телефон</td>
              <td class="date">Дата заявки</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="member in clubObject.financialClubMembers">
              <td class="name"> {{ member.name }} </td>
              <td class="lastname"> {{ member.lastname }} </td>
              <td class="email"> {{ member.email }} </td>
              <td class="phone"> {{ member.phone }}</td>
              <td class="date"> {{ member.date | filterDate }}</td>
              <td class="delete-member"><img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteClubMember(member.id)"/></td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Navbar from 'components/Events/Navbar'
import Meeting from 'components/Events/Meeting'
import Speaker from 'components/Events/ClubSpeaker'
import { VueEditor as Editor } from 'vue2-editor'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import * as VueGoogleMaps from 'vue2-google-maps'
import draggable from 'vuedraggable'
import uuidv4 from 'uuid/v4'
import router from '../../router'
import axios from 'axios'

export default {
  name: 'FinancialClub',
  data () {
    return {
      cityName: '',
      updateTimer: 0,
      cityAdditionVisible: false,
      talks: '',
      editableClub: null,
      dialogVisible: false,
      createdFor: '',
      placeUrl: '',
      newClubCity: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{ 'header': [2, false] }]
      ],
      urlEditorToolbar: [
        ['bold', 'italic', 'underline', 'link']
      ],
      announcement: {
        start: '',
        end: ''
      },
      center: null,
      markers: [],
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        autoHeight: false
      }
    }
  },
  computed: {
    ...mapState(['clubs', 'club']),
    clubsObject: {
      get () {
        return deepcopy(this.clubs)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].id === this.clubsObject.id) {
            val = this.clubsObject
          }
          val[i].order = i
        }

        this.updateFinancialClubs(val)
      }
    },
    clubObject () {
      if (this.club) {
        this.talks = this.club.talks
        this.placeUrl = this.club.placeUrl
        if (this.club.announcement) {
          this.announcement.start = this.club.announcement.startDate
          this.announcement.end = this.club.announcement.endDate
        }
      }
      return deepcopy(this.club)
    },
    logoContainerStyle () {
      return this.clubObject.logo
      ? {background: this.clubObject.logo.base64photo
        ? `url(${this.clubObject.logo.base64photo})`
        : `url(/upload/photos/${this.clubObject.logo}) #fff`,
        'background-size': 'contain'}
      : {background: ''}
    },
    headerStyle () {
      return this.clubObject.photo
      ? {background: this.clubObject.photo.base64photo ? `url(${this.clubObject.photo.base64photo})` : `url(/upload/photos/${this.clubObject.photo})`}
      : {background: ''}
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  },
  created () {
    const id = this.$route.params.id
    this.markers = []
    this.getFinancialClubs(id)
    if (id) {
      this.getFinancialClub(id)
    }
    this.center = {
      lat: 56.83779946755993,
      lng: 60.59916973114014
    }
  },
  methods: {
    ...mapActions(['getFinancialClubs',
      'addFinancialClub', 'getFinancialClub',
      'updateFinancialClub', 'loadClubSponsorPhoto',
      'addMeeting', 'addClubSpeaker',
      'addClubAnnouncement', 'deleteClubAnnouncement',
      'loadClubPhoto', 'deleteClub', 'loadClubLogoImage',
      'deleteClubLogoImage', 'loadClubBackgroundPhoto', 'saveFinancialClib',
      'updateFinancialClubs', 'deleteClubMember']),
    toggleCityAddition () {
      this.cityAdditionVisible = !this.cityAdditionVisible
    },
    handleAddSpeaker () {
      this.addClubSpeaker({ id: uuidv4(), financial_club_id: this.clubObject.id, order: this.clubObject.clubSpeakers.length })
    },
    handleAddMeeting () {
      this.addMeeting({ id: uuidv4(), financial_club_id: this.clubObject.id })
    },
    handleAddAnnouncement () {
      this.clubObject.announcement = { financial_club_id: this.clubObject.id, id: uuidv4() }
      this.handleUpdateFinancialClub()
    },
    showMembers () {
      this.dialogVisible = true
    },
    selectAddress (data) {
      this.clubObject.location = `${data.latLng.lat()}, ${data.latLng.lng()}`
      this.markers = []
      const position = { lat: data.latLng.lat(), lng: data.latLng.lng() }
      this.markers.push({ position })
      setTimeout(() => { this.center = position }, 400)
      this.handleUpdateFinancialClub()
    },
    deleteSponsorLogo (logo) {
      this.clubObject.logos = this.clubObject.logos.filter(l => {
        return l.id !== logo.id || l !== logo
      })
      this.handleUpdateFinancialClub()
    },
    deleteClubPhoto (photo) {
      this.clubObject.photos = this.clubObject.photos.filter(p => {
        return p.id !== photo.id || p !== photo
      })
      this.handleUpdateFinancialClub(this.clubObject)
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.clubObject.logos.push({
          base64photo: e.target.result,
          data: formData,
          id: uuidv4()
        })
        this.handleUpdateFinancialClub()
      }
    },
    handleLoadClubBackgroundPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.clubObject.photo = {
          base64photo: e.target.result,
          data: formData
        }
        this.updateFinancialClub(this.clubObject)
      }
    },
    loadPhotoLogoImage (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.clubObject.logo = {
          base64photo: e.target.result,
          data: formData
        }
        this.updateFinancialClub(this.clubObject)
      }
    },
    handleLoadPhoto () {
      this.$refs.loadPhotoButton.click()
    },
    deletePin () {
      this.clubObject.location = ''
      this.markers = []
      this.handleUpdateFinancialClub()
    },
    handleAddCity () {
      const newCLub = {
        city: this.cityName,
        id: uuidv4(),
        isNew: true,
        meetings: [],
        clubSpeakers: [],
        announcement: null,
        financialClubMembers: [],
        photos: [],
        logos: []
      }
      this.addFinancialClub(newCLub)
      router.push({ name: 'FinancialClub', params: { id: newCLub.id } })
      this.cityName = ''
      this.toggleCityAddition()
    },
    handleGetClub (id) {
      this.getFinancialClub(id)
    },
    handLoadClubPhoto (id) {
      this.$refs.loadBackgroundPhoto.click()
    },
    handleLoadLogoImage () {
      this.$refs.loadLogoImage.click()
    },
    handleAddClubPhoto () {
      this.$refs.loadClubPhotoButton.click()
    },
    handleSaveFinancialClib () {
      this.saveFinancialClib(this.clubObject)
    },
    clubPhotoAdded (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.clubObject.photos.push({
          base64photo: e.target.result,
          data: formData,
          id: uuidv4()
        })
        this.updateFinancialClub(this.clubObject)
      }
    },
    announcementDateChanged () {
      this.clubObject.announcement.startDate = this.announcement.start
      this.clubObject.announcement.endDate = this.announcement.end
      this.handleUpdateFinancialClub()
    },
    toggleEditClub (id) {
      if (this.editableClub === id) {
        id = null
        this.newClubCity = ''
      } else {
        const club = this.clubsObject.find(a => a.id === id)
        this.newClubCity = club.city
      }
      this.editableClub = id
    },
    handleUpdateFinancialClub () {
      this.updateFinancialClub(this.clubObject)
    },
    handleUpdateFinancialClubs () {
      const club = this.clubsObject.find(a => a.id === this.editableClub)
      club.city = this.newClubCity
      this.editableClub = null
      this.updateFinancialClubs(this.clubsObject)
    },
    getAddress () {
      clearTimeout(this.geocoderTimer)
      const axiosInstance = axios.create()
      const place = encodeURIComponent(`${this.clubObject.city} ${this.clubObject.address}`)
      axiosInstance.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${place}&key=AIzaSyC36JGZn_Nl3Go2QyT9PQdnT8uACjbrSdE`)
      .then(({ data }) => {
        if (data.results[0]) {
          this.center = data.results[0].geometry.location
        }
      })
    }
  },
  watch: {
    talks (value) {
      this.clubObject.talks = value
    },
    placeUrl (value) {
      this.clubObject.placeUrl = value
    },
    club (value) {
      if (value && value.location) {
        const point = value.location.split(',')
        const position = {
          lat: parseFloat(point[0]), lng: parseFloat(point[1])
        }
        this.center = position
        this.markers.push({
          position: position
        })
      }
      this.createdFor = value.createdFor
    },
    clubObject (value) {
      if (!value.location) {
        this.getAddress()
      }
    },
    createdFor (value) {
      this.clubObject.createdFor = value
      this.handleUpdateFinancialClub()
    }
  },
  components: { Navbar, Editor, Meeting, Speaker, VueGoogleMaps, draggable }
}
</script>

<style scoped>
@import "../../global.css";
.event {
  background: #eee;
  padding: 100px;
  color: black;
  flex-direction: column;
}
.club-header-wrapper {
  background: #eee;
  justify-content: center;
}
.delete-club-photo {
  margin: 15px 0 0;
}
.club-header {
  padding: 20px 30px;
  max-width: 950px;
}
.club-header .control {
  margin: 16px 0;
}
.club-information {
  margin: 25px;
}
.additional-information {
  background: #eee;
  padding: 20px;
  margin-left: 25px;
}
.editor-container {
  padding-right: 30px;
}
.benefits {
  min-width: 300px;
  width: 600px;
  text-align: center;
  margin: 30px 0;
}
.logo-wrapper {
  position: relative;
}
.delete-icon {
  top: -9px;
  right: -9px;
}
.meetings {
  margin: 20px 0;
}
.speakers {
  max-width: 1200px;
  margin: 0 auto -10px !important;
}
.club-footer {
  margin: 20px 0 0;
}
.club-footer .column {
  padding: 18px;
}
.club-footer .delete-club {
  background: red;
  color: white;
  cursor: pointer;
}
.club-footer .hide {
  background: #a8c6fa;
}
.club-photo {
  margin: 15px 0 0;
  width: 160px;
  height: 160px;
}
h2.has-text-centered {
  margin: 40px  0 5px 0;
}
.logo-wrapper {
  max-width: 210px;
}
.members-link {
  display: inline-block;
  padding: 10px 0 20px;
}
.webinar-title {
  font-weight: bold;
  font-size: 16px;
}
.club {
  margin: 12px;
}
.swiper-slide {
  margin-bottom: 20px;
}
</style>
<style>
#talks {
  height: 215px;
}
#place-url {
  height: 100px;
}
.club-wrapper .el-dialog {
  min-width: 850px;
  max-width: 850px
}
.club-members > span {
  display: block;
  text-align: center;
}
.club-members-count {
  font-weight: bold;
  margin: 5px 0;
  font-size: 1.2em;
}
.club-members-table tr {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 10px 0;
  display: block;
}
.club-members-table td {
  padding: 8px 14px;
  min-width: 150px;
  max-width: 33%;
}
.club-members-table .name {
  min-width: 120px;
  max-width: 120px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
}
.club-members-table .lastname {
  min-width: 170px;
  max-width: 170px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
}
.club-members-table .email {
  min-width: 200px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.club-members-table .phone {
  min-width: 150px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.club-members-table .date {
  min-width: 135px;
  max-width: 135px;
}
.delete-member {
  position: relative;
  top: 15px;
  right: 33px;
  width: 20px !important;
  min-width: 20px !important;
}
</style>



// WEBPACK FOOTER //
// FinancialClub.vue?ed4ab4f0